import { useTranslation } from "react-i18next";
import { EmailIcon, FacebookIcon, InstagramIcon, LocationIcon, PinterestIcon, WhatsappIcon } from "../../assets/images/icons/socialMedia";
import { whiteTextLogo } from "../../assets/images/logos";
import Newsletter from "./Newsletter";

export default function Footer() {
  const { t } = useTranslation();

  const socialLinks = [
    // { link: "https://www.facebook.com/", icon: <FacebookIcon /> },
    {
      link: "https://www.instagram.com/thunderclos?igsh=MW1kbnFpOXNyZHg0eQ==",
      icon: <InstagramIcon />,
    },
    // { link: "https://www.pinterest.com/", icon: <PinterestIcon /> },
    { link: "https://wa.me/212774804516", icon: <WhatsappIcon /> },
  ];

  const footerLinks = [
    {
      main: "product-categories",
      other: [
        "category-carousel.sweatshirts",
        "category-carousel.tracksuits",
        "category-carousel.jackets",
        "category-carousel.jeans",
        "category-carousel.shirts",
        "category-carousel.jerseys",
        "category-carousel.accessories",
      ],
    },
    // {
    //   main: "customer-service.item1",
    //   other: [
    //     "customer-service.item2",
    //     "customer-service.item3",
    //     "customer-service.item4",
    //     "customer-service.item5",
    //   ],
    // },
    // {
    //   main: "about-us.item1",
    //   other: [
    //     "about-us.item2",
    //     "about-us.item3",
    //     "about-us.item4",
    //     "about-us.item5",
    //   ],
    // },
  ];

  const infoLinks = [
    {
      text: "Maarif, Rue Ibnou Mounir, near Café l’Unik, Casablanca",
      icon: <span className="mt-1"><LocationIcon /></span>,
    },
    { text: "thundermaroc2025@gmail.com", icon: <span className=""><EmailIcon /></span>, href: "mailto:thundermaroc2025@gmail.com" },
  ];

  return (
    <footer className="bg-black text-white pt-10 pb-6">
      <div className="container mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          {/* === LOGO & SOCIAL === */}
          <div className="order-1 md:order-none">
            <img loading="lazy" src={whiteTextLogo} className="w-40 h-auto" alt="logo" />
            <p className="mt-4 text-gray-300 text-sm leading-relaxed">{t("logo-footer-text")}</p>

            <div className="mt-6 flex flex-row flex-wrap gap-4">
              {socialLinks.map((item, i) => (
                <a key={i} href={item.link} target="_blank" rel="noopener noreferrer" className="transition-transform duration-300 hover:scale-110">
                  {item.icon}
                </a>
              ))}
            </div>
          </div>

          {/* === FOOTER LINKS === */}
          {footerLinks.map((group, i) => (
            <div key={i} className="order-3 md:order-none">
              <h2 className="font-semibold uppercase text-sm mb-3 border-b border-gray-700 pb-1">{t(group.main)}</h2>
              <ul className="space-y-2">
                {group.other.map((link, j) => (
                  <li key={j}>
                    <a href="/#_" className="text-gray-400 text-sm hover:text-white transition-colors duration-200">
                      {t(link)}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* === INFO LINKS (USE infoLinks array) === */}
          <div className="order-4 md:order-none">
            <h2 className="font-semibold uppercase text-sm mb-3 border-b border-gray-700 pb-1">{t("contact-info")}</h2>
            <ul className="space-y-3">
              {infoLinks.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  {item.icon}
                  {item.href ? <a href={item.href} className="text-sm text-gray-300 leading-snug truncate">{item.text}</a>
                    : <p className="text-sm text-gray-300 leading-snug">{item.text}</p>}
                </li>
              ))}
            </ul>
          </div>

          {/* === NEWSLETTER === */}
          <div className="order-2 md:order-none">
            <Newsletter t={t} />
          </div>
        </div>

        {/* === COPYRIGHT === */}
        <p className="border-t border-gray-700 mt-10 pt-4 text-center text-xs text-gray-400">{t("copyright")}</p>
      </div>
    </footer>
  );
}
